import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewWillEnter,ViewWillLeave } from '@ionic/angular';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { MobileHomeRoutes } from '../../mobile.routes';
import { ToasterService } from '../../../../common/services/toaster.service';
import { MenuController, ViewDidLeave, ViewDidEnter } from '@ionic/angular';

@Component({
  selector: 'app-mobile-home-page',
  templateUrl: 'mobile-home.page.html',
  styleUrls: [
    './mobile-home.page.scss'
  ]
})
export class MobileHomePage  {

  public routes = MobileHomeRoutes;

  constructor(
    private route: ActivatedRoute,
      public menu: MenuController,
    private router: Router,
    public authService: GtrakAuthService,
    private toasterService: ToasterService
  ) { 
  
  }



  ionViewWillEnter() {
    
  document.body.classList.add('hide-menu');
  this.menu.enable(false);
}

ionViewWillLeave() {
  document.body.classList.remove('hide-menu');
  this.menu.enable(true);
}
  async logout(): Promise<void> {
    const user = this.authService.user;
    await this.authService.Logout();
    this.router.navigate([user.homeAuthLocation]);
    this.toasterService.presentToast("success", "You have been logged out", "Success");
  }

}